import type { SVGProps } from 'react';

export const Lightbulb = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="23.3px"
    role="img"
    viewBox="0 0 16 23.3"
    width="16px"
    x="0px"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    y="0px"
    // style={{ enableBackground: 'new 0 0 16 23.3' }}
    {...props}
  >
    <title>{'lightbulb'}</title>
    <g>
      <path
        d="M8,0C3.6,0,0,3.6,0,8c0,2.9,2.7,6,3.7,8.8C5.1,20.8,5,23.3,8,23.3c3.1,0,2.9-2.4,4.3-6.5
        		C13.3,14,16,10.9,16,8C16,3.6,12.4,0,8,0z M9.9,19.8l-3.6,0.5c-0.1-0.4-0.3-0.8-0.4-1.4c0,0,0,0,0,0l4.5-0.6
        		c-0.1,0.2-0.1,0.4-0.2,0.6C10.1,19.2,10,19.5,9.9,19.8z M5.6,18.1c-0.1-0.4-0.3-0.9-0.4-1.4h5.6c-0.1,0.3-0.2,0.5-0.3,0.8L5.6,18.1
        		z M8,21.8c-0.7,0-1.1-0.1-1.5-0.9l3.1-0.4C9.2,21.7,8.9,21.8,8,21.8z M11.4,15.3H4.6c-0.4-0.8-0.8-1.6-1.2-2.3
        		C2.4,11.2,1.5,9.5,1.5,8c0-3.6,2.9-6.5,6.5-6.5c3.6,0,6.5,2.9,6.5,6.5c0,1.5-1,3.2-1.9,4.9C12.2,13.7,11.8,14.5,11.4,15.3z"
      />
      <path
        d="M8,3.6c-2.4,0-4.4,2-4.4,4.4c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4C4.4,6,6,4.4,8,4.4
        		c0.2,0,0.4-0.2,0.4-0.4C8.4,3.8,8.2,3.6,8,3.6z"
      />
    </g>
  </svg>
);
